import React, { useMemo } from "react";
import { CourseReportContextProps } from "../../context";
import { Skill } from "src/types/coaching/courses";
import { UserGroup } from "src/types/users";
import moment from "moment";

import styles from "./styles.module.scss";
import cx from "classnames";
import _ from "lodash";

interface SelectedFiltersProps {
  reportContext: CourseReportContextProps;
  onRemoveSkill: (skill: string) => void;
  onRemoveGroup: (group: string) => void;
}

const SelectedFilters: React.FC<SelectedFiltersProps> = ({
  reportContext,
  onRemoveSkill,
  onRemoveGroup,
}) => {
  const { userGroups, skills, startDate, endDate } = reportContext;

  const groupsArr: UserGroup[] = userGroups?.slice(0, 2) || []; 
  const skillsArr: Skill[] = skills?.slice(0, 2) || []; 

  const extraGroups = _.size(userGroups) - _.size(groupsArr);
  const extraSkills = _.size(skills) - _.size(skillsArr);

  const getDateRange = (start: Date, end: Date) => {

    if( moment(start).isSame(moment(end), "day") ) {
      return moment(start).format("D MMM YYYY");
    }else {
      return `${moment(start).format("D MMM YYYY")} - ${moment(end).format("D MMM YYYY")}`;
    }
  };


  return (
    <div className={styles.container}>
      {startDate && endDate && (
        <div
          className={cx(styles.date, {
            [styles.seperator]: _.size(userGroups) || _.size(skills) > 0,
          })}
        >
          <div className={styles.values}>
            <div className={styles.valueItem}>
              {getDateRange(startDate, endDate)}
            </div>
          </div>
        </div>
      )}

      {_.size(userGroups) > 0 && (
        <div
          className={cx(styles.groupsWrapper, {
            [styles.seperator]: _.size(skills) > 0,
          })}
        >
          <div className={styles.groups}>
            <div className={styles.label}>Groups:</div>
            <div className={styles.values}>
              {groupsArr.map((group: UserGroup) => (
                <div className={styles.valueItem}>
                  {group?.name}
                  <span
                    className={cx("paperflite-close", styles.close)}
                    onClick={() => onRemoveGroup(group?.id)}
                  />
                </div>
              ))}
            </div>
          </div>
          {extraGroups > 0 && _.size(userGroups) > 2 && (
            <div className={styles.more}>
              <div className={styles.valueItem}> + {extraGroups} more</div>
            </div>
          )}
        </div>
      )}

      {_.size(skills) > 0 && (
        <div className={styles.skillsWrapper}>
          <div className={styles.skills}>
            <div className={styles.label}>Skills:</div>
            <div className={styles.values}>
              {skillsArr.map((skill: Skill) => (
                <div className={styles.valueItem}>
                  {skill.name}
                  <span
                    className={cx("paperflite-close", styles.close)}
                    onClick={() => onRemoveSkill(skill.id!)}
                  />
                </div>
              ))}
            </div>
          </div>
          {extraSkills > 0 && _.size(skills) > 2 && (
            <div className={styles.more}>
              <div className={styles.valueItem}> + {extraSkills} more</div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SelectedFilters;
